module.exports = __webpack_public_path__ + "static/media/elgin-logo-white.9a89df89.png";